module.exports = __webpack_public_path__ + "static/media/key1.7a955288.svg";